module.exports = __webpack_public_path__ + "b9adff5e624028fa3f9cd48372430aba.svg";